(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wishlist-button"] && !Shopify.designMode) return;
  try {
    if (!window.__wishlistButtonInit) {
    window.__wishlistButtonInit = true;

    function setWishlistButtonState(btn, inWishlist) {
      var path = btn.querySelector('path');
      var fill = inWishlist ? '#ff5353' : 'none';
      var color = inWishlist ? '#ff5353' : '#C8C8B6';
      var label = inWishlist
        ? (btn.getAttribute('data-label-remove') || 'Remove from wishlist')
        : (btn.getAttribute('data-label-add') || 'Add to wishlist');

      btn.setAttribute('data-in-wishlist', inWishlist ? 'true' : 'false');
      btn.setAttribute('aria-label', label);
      if (path) {
        path.setAttribute('fill', fill);
        path.setAttribute('stroke', color);
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-button]');
      if (!btn || btn.disabled) return;

      e.preventDefault();
      e.stopPropagation();

      var productGid = btn.getAttribute('data-product-gid');
      var customerId = btn.getAttribute('data-customer-id');
      var previous = btn.getAttribute('data-in-wishlist') === 'true';
      var next = !previous;

      var allButtons = document.querySelectorAll('[data-product-gid="' + productGid + '"]');
      allButtons.forEach(function (b) { setWishlistButtonState(b, next); b.disabled = true; });

      fetch('/a/v/api/toggle-wishlist-product', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productGid: productGid, customerId: customerId }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Request failed: ' + res.status);
          return res.json();
        })
        .then(function (data) {
          if (data && data.wishlist) {
            var authoritative = data.wishlist.indexOf(productGid) !== -1;
            allButtons.forEach(function (b) { setWishlistButtonState(b, authoritative); });
            document.dispatchEvent(new CustomEvent('wishlist:updated', {
              detail: { count: data.wishlist.length }
            }));
          }
        })
        .catch(function (err) {
          console.error('wishlist toggle failed', err);
          allButtons.forEach(function (b) { setWishlistButtonState(b, previous); });
        })
        .finally(function () {
          allButtons.forEach(function (b) { b.disabled = false; });
        });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
